import { Component, Input } from '@angular/core';

@Component({
	selector: 'ws-expansion-section-header',
	templateUrl: './expansion-section-header.component.html',
	styleUrls: ['./expansion-section-header.component.scss'],
})
export class ExpansionSectionHeaderComponent {
	@Input() label: string = '';
}
